import newStyled from "@emotion/styled";
import { motion } from "framer-motion";

const DotsLoadingIndicator = newStyled(motion.div)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  align-self: flex-start;
  .dot {
    width: 8px;
    height: 8px;
    background: ${props => props.color || '#F43F60'};
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;
  }
  .dot:nth-of-type(1) { animation-delay: 0s; }
  .dot:nth-of-type(2) { animation-delay: 0.2s; }
  .dot:nth-of-type(3) { animation-delay: 0.4s; }
  @keyframes typing {
    0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
    30% { transform: translateY(-4px); opacity: 1; }
  }
`;

function DotsLoading({ dots = 3, color }) {
    return <DotsLoadingIndicator color={color}>
        {Array.from({ length: dots }).map((_, index) => (
            <div key={index} className="dot" />
        ))}
    </DotsLoadingIndicator>
}

export default DotsLoading;